<template>
  <base-auth>
    <div id="before_code_verify">
        <form @submit.prevent="onSubmit" id="phone_number_form">
            <vue-recaptcha
                v-if="captchaDriver === 'recaptcha'"
                ref="sendCode"
                @verify="onVerify"
                @expired="onExpired"
                size="invisible"
                :sitekey="sitekey"
                :loadRecaptchaScript="true">
            </vue-recaptcha>
            <arcaptcha-vue
                v-if="captchaDriver === 'arcaptcha'"
                ref="arcaptchaSendCode"
                :site_key="arCaptchaKey"
                :invisible="true"
                :callback="onArcaptchaSuccess"
                :expired_callback="onArcaptchaExpired"
                :error_callback="onArcaptchaError"
            />
            <div class="login-form">
                <h1 class="m-0 mb-2 text-white-in-dark-mode text-right pr-5">{{ $t( passwordChangeMessage ||'auth.title.recover_pass') }}</h1>
                <div class="kt-login__form" id="message_div"></div>
                <div class="form-field" style="direction: rtl">
                    <input
                        v-bind:placeholder="$t('auth.placeholder.short_phone')"
                        name="phone"
                        id="phone"
                        v-model="phone"
                        type="text"
                        class="mt-2"
                    >
                </div>
                <div class="login-footer" style="margin-top: 10px">
                    <button
                        type="submit"
                        id="phone_number_submit"
                    >
                        {{ $t('auth.btn.send_code') }}
                    </button>
                </div>
            </div>
        </form>
        <verify-code :phone="phone" v-model="code" @resendCode="resendCode"/>
    </div>
    <div id="change_pass" class="kt-login__form disp-none">
      <reset-password :phone="phone" :code="code" @showMessage="handleMessage"/>
    </div>
  </base-auth>
</template>

<script>
import baseAuth from '@/components/base-auth'
import { authService } from '@/common/api.service'
import $ from 'jquery'
import VueRecaptcha from "vue-recaptcha";
import { reCaptchaKeys } from '@/constants/getRecaptchaKey'
import { arCaptchaKeys } from '@/constants/getArCaptchaKey'
import { getCaptchaDriver } from '@/constants/getCaptchaDriver'
import VerifyCode from '@/views/auth/VerifyCode.vue';
import ResetPassword from '@/views/auth/ResetPassword.vue';
import ArcaptchaVue from 'arcaptcha-vue'

export default {
  data() {
    return {
      phone: '',
      code: '',
      time_counter: 60,
      login_event: null,
      agree: false,
      recaptcha_verified: false,
      g_recaptcha_response: "",
      sitekey: reCaptchaKeys,
      arCaptchaKey: arCaptchaKeys,
      captchaDriver: getCaptchaDriver,
      arcaptchaToken: '',
      arcaptchaVerified: false,
      message: this.$route.query.message || '',
      passwordChangeMessage: sessionStorage.getItem('passwordChangeMessage') || '',
    }
  },

  beforeDestroy() {
    sessionStorage.removeItem('passwordChangeMessage')
  },

  components: {
      ResetPassword,
      VerifyCode,
    'base-auth': baseAuth,
    "vue-recaptcha": VueRecaptcha,
    ArcaptchaVue,
  },
    methods: {
    onSubmit(e){
      this.executeCaptcha();
      this.login_event = e;
    },
    executeCaptcha() {
      if (this.captchaDriver === 'recaptcha') {
        this.$refs.sendCode.execute();
      } else if (this.captchaDriver === 'arcaptcha') {
        this.arcaptchaVerified = false;
        this.arcaptchaToken = '';
        this.$refs.arcaptchaSendCode.execute();
      } else if (!this.captchaDriver || this.captchaDriver === 'none') {
        this.sendCode();
      }
    },
    sendCode() {
      let btn = $('#phone_number_submit')
      let form = $('#phone_number_form')
      let code_form = $('#code_form')
      let resend_code_section = $('#resend_code_section')
      let phone = $('#phone')

      form.validate({
        ignore: ".ignore",
        rules: {
          phone: {
            required: true
          },
        }
      })

      if(!form.valid()) {
        return
      }

      if (!this.isCaptchaVerified()) {
        return;
      }

      btn.prop("disabled", true);
      btn.html(`<div class="d-flex justify-content-center align-items-center"><div class="px-2">لطفا صبر کنید</div><div class="spinner-border spinner-border-sm text-white" role="status"></div></div>`);

      let params = {
        phone: this.phone,
      }

      if (this.captchaDriver === 'recaptcha') {
        params['g-recaptcha-response'] = this.g_recaptcha_response;
      } else if (this.captchaDriver === 'arcaptcha') {
        params['g-recaptcha-response'] = this.arcaptchaToken;
      }

      authService.sendForgetPassCode(params)
          .then(() => {
            btn.addClass('disp-none')
            code_form.removeClass('disp-none')
            resend_code_section.removeClass('disp-none')
            phone.attr( "disabled", "disabled" )
            this.resendCounter(60)
          })
          .catch((error) => {
            if (error.response.data.data)
              form.validate().showErrors(error.response.data.data)
            else
              this.showMsg(form, 'danger', error.response.data.message)
          })
          .finally(() => {
              this.resetCaptcha()
              btn.prop("disabled", false);
            btn.html('ارسال کد');
          })
    },
    resendCounter(timeout) {
      var count = timeout

      let internal = setInterval(function () {
        let t = count - 1
        count -= 1
        $("#timer_span").empty().append(t);

        if (count < 1) {
          $('#resend_counter_div').addClass('disp-none')
          $('#resend_btn').removeClass('disp-none')
          clearInterval(internal);
        }
      }, 1000)
    },
    resendCode(){
      let form = $('#phone_number_form')
      let btn = $('#resend_btn')
      let code_field = $('#code')
      let resend_counter_div = $('#resend_counter_div')

      code_field.val('*****')

      let params = {
        phone: this.phone,
      }

      if (this.captchaDriver === 'recaptcha') {
        params['g-recaptcha-response'] = this.g_recaptcha_response;
      } else if (this.captchaDriver === 'arcaptcha') {
        params['g-recaptcha-response'] = this.arcaptchaToken;
      }

      authService.resendCode(params)
          .then((response) => {
            btn.addClass('disp-none')
            resend_counter_div.removeClass('disp-none')
            this.resendCounter(120)
            this.showMsg(form, 'success', response.data.message)
          })
          .catch((error) => {
            this.showMsg(form, 'danger', error.response.data.message)
          })
          .finally(() => {
            code_field.val('')
          })
    },
    onVerify(response) {
      this.recaptcha_verified = true;
      this.g_recaptcha_response = response;
      this.sendCode(this.login_event);
    },
    onExpired() {
      this.recaptcha_verified = false;
    },
    onArcaptchaSuccess(token) {
      this.arcaptchaToken = token;
      this.arcaptchaVerified = true;
      this.sendCode(this.login_event);
    },
    onArcaptchaExpired() {
      this.arcaptchaVerified = false;
      this.arcaptchaToken = '';
    },
    onArcaptchaError(error) {
      this.arcaptchaVerified = false;
      this.arcaptchaToken = '';
      this.showMsg($('#phone_number_form'), 'danger', 'Captcha verification failed. Please try again.');
    },
    resetCaptcha() {
      if (this.captchaDriver === 'recaptcha') {
        this.$refs.sendCode && this.$refs.sendCode.reset();
      } else if (this.captchaDriver === 'arcaptcha') {
        this.$refs.arcaptchaSendCode && this.$refs.arcaptchaSendCode.reset();
        this.arcaptchaVerified = false;
        this.arcaptchaToken = '';
      }
    },
    isCaptchaVerified() {
      if (this.captchaDriver === 'recaptcha') {
        return this.recaptcha_verified;
      } else if (this.captchaDriver === 'arcaptcha') {
        return this.arcaptchaVerified && this.arcaptchaToken;
      } else if (!this.captchaDriver || this.captchaDriver === 'none') {
        return true;
      }
      return false;
    },
    
    showMsg(form, type, message) {
      console.log(`${type}: ${message}`);

      if (type === 'danger' && message.includes('rate limit')) {
        return;
      }

      if (window.toastr) {
        window.toastr[type](message);
      }

            form.find('.alert').remove();
      
      let alertClass = type === 'success' ? 'alert-success' : 'alert-danger';
      let alertHtml = `
        <div class="alert ${alertClass} alert-dismissible fade show" role="alert">
          <div class="alert-text">${message}</div>
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      `;

    },
  }
}
</script>

<style>
.disp-none {
  display: none !important;
}
.make-hover:hover {
  color: #5d78ff!important;
}
</style>